export default __webpack_public_path__ + "media/images/chairs-f171498d72b35d705c9f93056a729962.svg";